import AssessmentIcon from '@mui/icons-material/Assessment';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import PaymentsIcon from '@mui/icons-material/Payments';
import BlockIcon from '@mui/icons-material/Block';

const icons = {
  AssessmentIcon, InsertChartOutlinedIcon,
  PaymentsIcon, BlockIcon
};


const MISreport = {
  id: 'mis-report',
  title: 'MIS Report',
  type: 'group',
  children: [
    {
      id: 'businessMIS',
      title: 'Business MIS Report',
      type: 'item',
      url: '/business-MIS-report',
      icon: icons.AssessmentIcon
    },
    {
      id: 'customMIS',
      title: 'Custom MIS Report',
      type: 'item',
      url: '/custom-MIS-report',
      icon: icons.InsertChartOutlinedIcon,
    },
    {
      id: 'paymentOutstanding',
      title: 'Payment Report',
      type: 'item',
      url: '/payment-MIS-report',
      icon: icons.PaymentsIcon,
    },
    {
      id: 'inactiveDealer',
      title: 'Inactive Dealer Report',
      type: 'item',
      url: '/inactive-dealer-MIS-report',
      icon: icons.BlockIcon,
    }
  ]
};

export default MISreport;
